export const SIMILARITY_PRESS_INFO_TEXT =
  "이 팝업창 (중복 체크 알림 (Overlapped Alert))에서, Press와 Filing 간의 Unsuitable(Overlapped) 체크박스를 체크하시면, 반드시 Filing이 Unsuitable(Overlapped with merging) 처리되니, Press에서 DB 작업을 마무리 하시면 됩니다.";
